import Grid from "@material-ui/core/Grid";
import React from "react";
import StringFormat from "../../../util/string-format";
import CardButton from "./CardButton";
import BaseKeyListener from "./listeners/BaseKeyListener";

const DynamicActions = ({
	columns = 4,
	buttonSize,
	textAlign,
	transitions = [],
	onSelect,
	currentTransition,
	hideIcons,
	disableKeyListener = false
}) => {
	const sm = 12 / columns;

	const getButtonText = (transition) => {
		return StringFormat.formatTextWithKeystroke(
			transition.displayName,
			transition.keyStroke
		);
	};

	return (
		<Grid container spacing={1}>
			{transitions
				.filter((t) => !t.showInToolbar)
				.map((t) => (
					<Grid item xs={12} sm={sm} key={t.name}>
						<CardButton
							id={t.name}
							size={buttonSize}
							textAlign={textAlign}
							text={getButtonText(t)}
							icon={!hideIcons && t.icon}
							onClick={() => onSelect(t.name)}
							active={currentTransition === t.name}
							team={t.team}
						/>
					</Grid>
				))}
			<Grid item xs={12}>
				{!disableKeyListener && (
					<BaseKeyListener
						items={transitions}
						onSelected={(t) => onSelect(t.name)}
					/>
				)}
			</Grid>
		</Grid>
	);
};

export default DynamicActions;
